import { HugeiconsIcon } from "@hugeicons/react";
import moment from "moment";
import { DATE_FORMATS } from "shared/app/TaskTableView/constants";

interface ActivityItemProps {
  id: string | number;
  title: string;
  sub: string | React.ReactNode;
  atISO: string;
  icon?: any;
}

export const ActivityItem = ({ item }: { item: ActivityItemProps }) => {
  return (
    <div className="flex gap-2 min-h-[128px] px-4">
      <div className="relative w-10 flex mt-6 justify-center">
        <div className="grid h-10 w-10 place-items-center rounded-full border border-alpha-100 bg-background-1000">
          <HugeiconsIcon
            icon={item.icon}
            className="text-content-1000"
            size={20}
            stroke="1.5px"
          />
        </div>
      </div>
      <div className="pt-6 max-w-[440px] w-full">
        <div className="bg-background-1000 border border-alpha-100 rounded-lg p-4 space-y-2">
          <h3 className="text-xs font-bold text-content-1000">{item.title}</h3>
          <p className="text-content-400 gap-2 text-sm break-words">
            {item.sub}
          </p>
        </div>
        <div className="flex mt-2 px-4 justify-end">
          <time
            className="text-sm text-content-300 whitespace-nowrap text-ellipsis"
            dateTime={item.atISO}
          >
            {moment(item.atISO).format(
              `${DATE_FORMATS.DATE} [at] ${DATE_FORMATS.TIME}`
            )}
          </time>
        </div>
      </div>
    </div>
  );
};
